import React, { useState } from "react";
import { ListChecks, X } from "lucide-react";
import { FORM_TYPE_OPTIONS } from "../../../../store/formsSlice";

export default function CreateFormModal({ open, onClose, onCreate }) {
  const [name, setName] = useState("");
  const [type, setType] = useState("pre-registration");

  if (!open) return null;

  const handleCreate = () => {
    onCreate({ name: name.trim(), type });
    setName("");
    setType("pre-registration");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-lg rounded-xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-start justify-between">
          <div className="flex items-start gap-3">
            <div className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-md bg-gray-100 text-gray-600">
              <ListChecks className="h-5 w-5" />
            </div>
            <div className="text-left">
              <h2 className="text-lg font-semibold text-[#1D2739]">
                Create New Supplier Form
              </h2>
              <p className="mt-1 text-sm text-gray-500">
                Choose a form type and give your form a name
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <label className="mb-1 block text-left text-sm font-medium text-gray-700">
          Form Name
        </label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g., Supplier Onboarding Form"
          className="mb-5 w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100"
        />

        <div className="space-y-3">
          {FORM_TYPE_OPTIONS.map((option) => (
            <label
              key={option.id}
              className={`flex cursor-pointer items-start gap-3 rounded-xl border px-4 py-3 ${
                type === option.id
                  ? "border-gray-400 bg-gray-50"
                  : "border-gray-200 hover:border-gray-300"
              }`}
            >
              <input
                type="radio"
                name="formType"
                checked={type === option.id}
                onChange={() => setType(option.id)}
                className="mt-1"
              />
              <span className="text-left">
                <span className="block text-sm font-semibold text-[#1D2739]">
                  {option.title}
                </span>
                <span className="mt-0.5 block text-sm text-gray-500">
                  {option.description}
                </span>
              </span>
            </label>
          ))}
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleCreate}
            className="rounded-lg bg-[#EAF524] px-4 py-2 text-sm font-semibold text-black hover:bg-[#e0eb1f]"
          >
            Create Form
          </button>
        </div>
      </div>
    </div>
  );
}
